import React, { useEffect, useState } from 'react';
import { Menu, X, Phone, Mail } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Close mobile menu on route change
  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);
  const navLinks = [{
    name: 'Home',
    href: '/'
  }, {
    name: 'People',
    href: '/people'
  }, {
    name: 'Research',
    href: '/research'
  }, {
    name: 'Equipment',
    href: '/equipment'
  }, {
    name: 'Publications',
    href: '/publications'
  }, {
    name: 'Projects',
    href: '/projects'
  }, {
    name: 'Collaborators',
    href: '/collaborators'
  }, {
    name: 'Gallery',
    href: '/gallery'
  }, {
    name: 'Weather',
    href: '/weather'
  }, {
    name: 'Contact',
    href: '/contact'
  }];
  return <header className="fixed w-full z-50 top-0 transition-all duration-300" data-id="element-197">
      {/* Top Utility Bar (Hidden on Mobile) */}
      <div className={`hidden md:block bg-[#4A0000] text-white/90 text-xs py-2 transition-all duration-300 ${scrolled ? 'h-0 overflow-hidden py-0 opacity-0' : 'opacity-100'}`} data-id="element-198">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center" data-id="element-199">
          <span data-id="element-200">Department of Mechanical Engineering, IIT Madras</span>
          <div className="flex items-center gap-6" data-id="element-201">
            <a href="tel:+914422574654" className="flex items-center gap-2 hover:text-white transition-colors" data-id="element-202">
              <Phone size={12} data-id="element-203" />
              <span data-id="element-204">+91 44 2257 4654</span>
            </a>
            <a href="mailto:arvindp@iitm.ac.in" className="flex items-center gap-2 hover:text-white transition-colors" data-id="element-205">
              <Mail size={12} data-id="element-206" />
              <span data-id="element-207">arvindp@iitm.ac.in</span>
            </a>
          </div>
        </div>
      </div>

      {/* Main Navigation */}
      <nav className={`w-full transition-all duration-300 ${scrolled ? 'bg-white shadow-md py-2' : 'bg-white/95 backdrop-blur-sm py-4 border-b border-gray-200/50'}`} data-id="element-208">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-209">
          <div className="flex justify-between items-center" data-id="element-210">
            {/* Logo Area */}
            <div className="flex items-center" data-id="element-211">
              <Link to="/" className="flex items-center gap-4 group" data-id="element-212">
                <img src="https://cdn.magicpatterns.com/uploads/5aPbZKWy7kwepY8EBvvSMu/imgi_19_download-removebg-preview.png" alt="IIT Madras Logo" className={`transition-all duration-300 ${scrolled ? 'h-12' : 'h-14'} w-auto group-hover:scale-105`} data-id="element-213" />
                <div className="flex flex-col" data-id="element-214">
                  <span className="text-2xl font-bold text-[#800000] font-serif tracking-wide" data-id="element-215">
                    MT²RL
                  </span>
                  <span className="text-xs text-gray-600 hidden lg:block max-w-[220px] leading-tight font-medium" data-id="element-216">
                    Multiscale Thermal Transport Research Laboratory
                  </span>
                </div>
              </Link>
            </div>

            {/* Desktop Menu */}
            <div className="hidden xl:flex xl:items-center xl:space-x-1" data-id="element-217">
              {navLinks.map(link => {
              const isActive = location.pathname === link.href;
              return <Link key={link.name} to={link.href} className={`relative px-3 py-2 text-sm font-semibold transition-colors group ${isActive ? 'text-[#800000]' : 'text-gray-700 hover:text-[#800000]'}`} data-id="element-218">
                    {link.name}
                    <span className={`absolute inset-x-0 bottom-0 h-0.5 bg-[#800000] transform origin-left transition-transform ${isActive ? 'scale-x-100' : 'scale-x-0 group-hover:scale-x-100'}`} data-id="element-219"></span>
                  </Link>;
            })}
            </div>

            {/* Mobile Menu Button */}
            <div className="flex items-center xl:hidden" data-id="element-220">
              <button onClick={() => setIsOpen(!isOpen)} className="text-gray-700 hover:text-[#800000] focus:outline-none p-2" data-id="element-221">
                {isOpen ? <X className="h-7 w-7" data-id="element-222" /> : <Menu className="h-7 w-7" data-id="element-223" />}
              </button>
            </div>
          </div>
        </div>

        {/* Animated Mobile Menu */}
        <AnimatePresence data-id="element-224">
          {isOpen && <motion.div initial={{
          opacity: 0,
          height: 0
        }} animate={{
          opacity: 1,
          height: 'auto'
        }} exit={{
          opacity: 0,
          height: 0
        }} transition={{
          duration: 0.3
        }} className="xl:hidden bg-white border-t border-gray-100 overflow-hidden shadow-xl absolute w-full" data-id="element-225">
              <div className="px-4 pt-2 pb-6 space-y-1" data-id="element-226">
                {navLinks.map(link => {
              const isActive = location.pathname === link.href;
              return <Link key={link.name} to={link.href} className={`block px-4 py-3 rounded-md text-base font-medium transition-colors ${isActive ? 'text-[#800000] bg-[#800000]/5' : 'text-gray-800 hover:text-[#800000] hover:bg-[#FAF9F7]'}`} data-id="element-227">
                      {link.name}
                    </Link>;
            })}

                {/* Mobile Utility Links */}
                <div className="mt-6 pt-6 border-t border-gray-100 space-y-4 px-4" data-id="element-228">
                  <a href="tel:+914422574654" className="flex items-center gap-3 text-sm text-gray-600" data-id="element-229">
                    <Phone size={16} className="text-[#800000]" data-id="element-230" />
                    <span data-id="element-231">+91 44 2257 4654</span>
                  </a>
                  <a href="mailto:arvindp@iitm.ac.in" className="flex items-center gap-3 text-sm text-gray-600" data-id="element-232">
                    <Mail size={16} className="text-[#800000]" data-id="element-233" />
                    <span data-id="element-234">arvindp@iitm.ac.in</span>
                  </a>
                </div>
              </div>
            </motion.div>}
        </AnimatePresence>
      </nav>
    </header>;
}